<template lang="html">
<div class="order-view main">

  <!-- 订单信息： -->
  <div v-if="order.id" class="order-item fs2">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">基本信息</van-tag>
              <!-- <i class="iconfont">&#xe606;</i> {{ order.sn }} -->
          </div>
          <div class="right c6" :class="order.status">{{ orderStatusText[order.status] }}</div>
      </div>
      <div class="mtm pbm order-item__bd">
          <div class="clear mtn order-item__info">
              <div class="left c6">订单名称：购买《{{ order.title }}》</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">订单编号：{{ order.sn }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">下单时间：{{ createdtime }}</div>
          </div>
          <div v-if="order.paidTime" class="clear mtn order-item__info">
              <div class="left c6">支付时间：{{ paidtime }}</div>
          </div>
          <div v-if="payment" class="clear mtn order-item__info">
              <div class="left c6">支付方式：{{ payment }}</div>
          </div>
          <div v-if="order.cardInfo && order.cardInfo.endTime" class="clear mtn order-item__info">
              <div class="left red">到期时间：{{ endtime }}</div>
          </div>
          <div v-if="order.cardInfo && order.cardInfo.totalNum" class="clear mtn order-item__info">
              <div class="left red">剩余练球次数：{{order.cardInfo.remainingNum}}/{{order.cardInfo.totalNum}}</div>
          </div>
          <div v-if="order.courseInfo && order.courseInfo.totalNum" class="clear mtn order-item__info">
              <div class="left red">剩余预约课时：{{order.courseInfo.remainingNum}}/{{order.courseInfo.totalNum}}</div>
          </div>
          <div v-if="order && order.courseStartTime" class="clear mtn order-item__info">
              <div class="left red">上课时间：{{ courseStartTime }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">订单类型：{{ ordertype }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c9"> <span v-show="ordertypeInfo"> 不支持</span>七天无理由退换货</div>
          </div>
          <div class="clear mtn order-item__price">
              <div class="right">合计：¥{{ order.amount }}</div>
          </div>
      </div>      
  </div>

  <!-- 俱乐部：显示 -->
  <div v-if="clubInfo" class="order-item fs2 mtm">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">俱乐部</van-tag>
          </div>
      </div>
      <div class="mtm pbm order-item__bd">
          <div class="clear mtn order-item__info">            
              <div class="left c6">名称：
                <router-link :to="{ name: 'venue',params:{clubId:clubInfo.id}}" class="blue">{{clubInfo.title}}</router-link>                
              </div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">地址：{{ clubInfo.address }}</div>
          </div>
          <div class="clear mtn order-item__info">
              <div class="left c6">营业时间：{{ clubInfo.businessStartTime }}:00 ~ {{ clubInfo.businessEndTime }}:00</div>
          </div>
      </div>
  </div>
  
  <!-- 课程表： 团课和私教课显示 并且是待付款和付款成功状态 -->
  <div v-show="courseBox" v-if="'created' == order.status || 'paid'==order.status" class="order-item fs2 mtm">
      <div class="clear pbm order-item__hd">
          <div class="left">
            <van-tag mark class="fs3 tag">课程表</van-tag>
          </div>
      </div>
      <div v-if="'created' == order.status" class="mtm pbm order-item__bd tac c9">
        <i class="my-model__icon iconfont rili">&#xe78f;</i>
        <p>支付后，查看课表</p>
      </div>
      <div v-else="'paid' == order.status">
        <div class="clear">
          <h2 class="mtm fs2">课程安排：</h2>
          <van-col v-if="courseList==''" class="mtn">暂无</van-col>
          <van-col v-if="courseList!=''" class="mtn" v-for="(item,index) in courseList" :key="index" span="12">{{index}} ：{{item.length}}课时</van-col>
        </div>
        <router-link v-if="courseList!=''" :to="{name: 'courseclassalone'}">
          <div class="mtm pbm order-item__bd tac green">
            <i class="my-model__icon iconfont rili green">&#xe78f;</i>
            <p>点击查看课表</p>
          </div>
        </router-link>
      </div>
  </div>
  
  <!-- 练球卡预约记录： -->
  <div v-show="record" class="order-item fs2 mtm">
    <div class="clear pbm order-item__hd">
        <div class="left">
          <van-tag mark class="fs3 tag">预约记录</van-tag>
        </div>
    </div>
    <div class="mtm pbm order-item__bd">
      <appointment-card v-for="item in reserveList" :key="item.id" :item="item" style="height:.8rem"></appointment-card>
    </div>
  </div>

  <!-- 退款： 退款中和退款完成状态显示 -->
  <div v-if="'refunding' == order.status || 'refunded'==order.status" class="order-item fs2 mtm">
    <div class="clear pbm order-item__hd">
        <div class="left">
          <van-tag mark class="fs3 tag">退款进度</van-tag>
        </div>
    </div>
    <div class="mtm pbm order-item__bd">
      <van-steps :active="active[order.refundStatus]" direction="vertical" :active-color="activeColor[order.refundStatus]">
        <van-step>发起退款<p class="mtn">{{refundCreatedTime}}</p></van-step>
        <van-step v-if="order.refundStatus!='cancelled'">俱乐部受理<p class="mtn" v-if="order.refundStatus=='refunding' || order.refundStatus=='success'">{{refundTime}}</p></van-step>
        <van-step v-if="order.refundStatus=='cancelled'">取消退款<p class="mtn" v-if="order.refundStatus=='cancelled'">{{refundTime}}</p></van-step>
        <van-step v-if="order.refundStatus!='failed' && order.refundStatus!='cancelled'">退款完成<p class="mtn" v-if="order.refundStatus=='success'">{{refundTime}}</p></van-step>
        <van-step v-if="order.refundStatus=='failed'">退款失败<p class="mtn" v-if="order.refundStatus=='failed'">{{refundTime}}</p></van-step>
      </van-steps>
    </div>
  </div>
  

  <!-- 操作：月卡不显示退款 -->
  <div class="mtm clear order-item__ft buybar bcw">
    <!-- 显示二维码（已付款） -->
    <div class="buybar__content mtn left" v-if="order.status == 'paid'"><i class="iconfont fs5" @click.stop="qrcode()">&#xe63e;</i></div>
    <div class="buybar__content clear right">   
        <van-button v-if="order.status == 'created'" type="default" size="small" class="mrn" @click="cancelOrder">取消订单</van-button>
        <van-button v-if="order.status == 'created'" type="primary" size="small" @click="goBuy">去支付</van-button>
        <van-button v-show="refundBtn" v-if="order.status == 'paid'" @click="refund" size="small" type="default">申请退款</van-button>
        <van-button v-show="refundBtn" v-if="order.status == 'refunding'" @click="cancelRefund" size="small" type="primary">取消退款</van-button>
        <router-link v-if="order.cardInfo && order.cardInfo.remainingNum>0" :to="{name: 'courseappointment',params: {orderId:order.cardInfo.orderId,itemId:order.cardInfo.productId,coachId:'-1',type:'clubPracticeCard'}}">
          <van-button size="small" type="primary">预约练球</van-button>
        </router-link>
        <router-link v-if="$route.params.targettype=='clubPtCourse' && order.status == 'paid'" :to="{name: 'courseappointment',params: {orderId:order.id,itemId:order.targetId,coachId:order.relateId,type:'clubPtCourse'}}">
          <van-button size="small" type="primary">预约课程</van-button>
        </router-link>
        <router-link v-if="order.status == 'paid' && isReview==false" :to="{name: 'evaluation',params:{courseId:order.targetId,courseType:order.targetType,relateId:order.relateId,orderId:order.id}}">
          <van-button v-show="praiseBtn" size="small" type="primary">去评价</van-button>
        </router-link>
        <van-button v-if="order.status == 'paid' && isReview==true" v-show="praiseBtn" size="small" type="default">您已评价</van-button>
      </div>
      <!-- <div class="right">
          <router-link :to="{ name: 'my'}"><van-button size="small">返回我的</van-button></router-link>
      </div> -->
  </div>
  <!-- 二维码 -->
  <div id="qrcodeWrap" class="qrcode-wrap" v-show="showcode" @click="cancleQrcode()"><div id="qrcode"></div></div>
</div>
</template>

<script>
import Vue from 'vue'
import { Toast,Tag,Step, Steps,Dialog  } from 'vant';
import Func from "@/assets/scripts/func";
import query from 'query-string';
import wx from 'weixin-js-sdk';
import QRCode from 'qrcodejs2'
import moment from 'moment';
import AppointmentCard from '@/components/AppointmentCard';
moment.locale('zh-cn');
Vue.use(Toast).use(Tag).use(Step).use(Steps).use(Dialog)
export default {
  inject:['reload'],  //注入reload方法
  name: 'OrderView',
  components: {
    AppointmentCard
  },
  data(){
    return {
      order: {},  // 订单信息
      clubInfo: {}, // 俱乐部信息
      ordertypeInfo:false ,//是否支持7天退换
      orderStatusText: {
        'created': '待付款',
        'paid': '付款成功',
        'refunding': '申请退款中',
        'refunded': '退款成功',
        'cancelled': '订单已取消'
      },
      courseBox: false,  //是否是 团课或者私教课
      record:false,   //练球卡预约记录显示
      active:{
        'created':0,
        'refunding':1,
        'success':2,
        'failed':2,
        'cancelled':1
      },  //退款步骤
      activeColor:{
        'created':'#06bf04',
        'refunding':'#06bf04',
        'success':'#06bf04',
        'failed':'#f60',
        'cancelled':'#06bf04'
      },
      reserveList:{}, //练球卡预约记录
      refundBtn:true,//退款按钮
      praiseBtn:false,//评价按钮
      courseList:{}, //课程信息
      isReview:false,  //是否评价
      showcode:false, //二维码
    }
  },
  created(){
    this.$nextTick(function () {
      let _this = this;
      var targettype = this.$route.params.targettype
      if(targettype=='clubGroupCourse'){
        // 团课订单
        this.$http.post('order/getClubGroupCourseOrderInfo',{
          orderId: this.$route.params.orderId
        }).then(res => {
          console.log(res)
          this.order = res.data.value.orderInfo
          this.clubInfo = res.data.value.clubInfo
          this.courseList = res.data.value.courseSchedule
          //是否评价
          this.isReview = res.data.value.isReview
          localStorage.courseList=JSON.stringify(res.data.value.courseSchedule);
        })   
      }else if(targettype=='clubPtCourse'){
        // 私教课订单
        this.$http.post('order/getClubPtCourseOrderInfo',{
          orderId: this.$route.params.orderId
        }).then(res => {
          console.log(res)
          this.order = res.data.value.orderInfo
          this.clubInfo = res.data.value.clubInfo
          this.courseList = res.data.value.courseSchedule
          //是否评价
          this.isReview = res.data.value.isReview
          localStorage.courseList=JSON.stringify(res.data.value.courseSchedule);
        })  
      }else if(targettype=='clubPracticeCard'){
        //练球卡订单
        this.$http.get('order/getClubDaysCardOrderInfo?orderId='+ this.$route.params.orderId).then(res => {
          console.log(res)
          this.order = res.data.value.orderInfo
          this.clubInfo = res.data.value.clubInfo
          this.reserveList = res.data.value.reserveList
        })  
      }else if(targettype=='clubMonthCard'){
        //月卡
        this.$http.get('order/getClubMonthCardOrderInfo?orderId='+ this.$route.params.orderId).then(res => {
          console.log(res)
          this.order = res.data.value.orderInfo
          this.clubInfo = res.data.value.clubInfo
        }) 
      }
    })   
  },
  methods: {
    goBuy(){
      // 跳转原主站支付页面
      let domain = location.origin
      location.href = `${domain}/m/pay_page?orderId=${this.order.id}&sn=${this.order.sn}&redirect=${encodeURIComponent(domain + '/venue/#/orderview/' + this.order.id +'/'+ this.order.targetType)}`;
    },
    refund(){ 
        let _this=this    
        Dialog.confirm({
            message: '确定要申请退款吗？'
        }).then(() => {
            // alert(_this.order.id)
          // 申请退款
            this.$http.post('order/applyRefund',{
              orderId: _this.order.id
            },{emulateJSON:true}).then(res => {
              console.log(res)
              if(!res.data.code){
                Toast('已申请')
                _this.order.status = 'refunding'
                _this.order.refundStatus='created'
                _this.reload()
              }else{
                Toast.fail(res.data.message)
              }
            },res => {
              // BUG? 在微信端申请退款的时候会走error
              // alert(res)
             _this.reload()
          })
        }).catch(() => {
            // on cancel
        })      
    },
    cancelRefund(){
       Dialog.confirm({
          message: '确定要取消退款吗？'
      }).then(() => {
        //取消退款
        this.$http.post('/order/cancelRefund',{
          orderId: this.order.id
        }).then(res => { 
          if(!res.data.code){
            Toast('已取消')
            // this.order.status = 'cancelled'
            this.order.refundStatus='cancelled'
            this.reload()
          }else{
            Toast.fail(res.data.message)
          }
          })
        }).catch(() => {
            // on cancel
        });      
    },
    cancelOrder(){
       Dialog.confirm({
            message: '确定取消订单吗？'
        }).then(() => {
          //取消订单
          this.$http.post('my_order/cancel',{
            id: this.order.id
          }).then(res => {   
            console.log(res)     
            
            // console.log(res.data.data.status)
            if(res.data.value.status=='cancelled'){
              Toast('已取消')
              this.order.status = 'cancelled'
            }else{
              Toast.fail('失败!')
            }
          })
        }).catch(() => {
            // on cancel
        });  
    },
    qrcode () {
      //生成二维码
      this.showcode = true;
      let qrcode = new QRCode('qrcode', {
          width: 150,
          height: 150, // 高度
          text: `${location.origin}/venue/#/scancodewriteoff?type=order&relateId=${this.$route.params.orderId}&targetType=${this.$route.params.targettype}`, // 二维码内容 网址为http或https开头
      })
    },
    cancleQrcode(){
      // 取消二维码
      this.showcode = false;
      document.getElementById('qrcodeWrap').innerHTML='<div id="qrcode"></div>'
    }
  },
  computed: {
    createdtime: function () {
      return moment(this.order.createdTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    paidtime: function () {
      return moment(this.order.paidTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    endtime: function(){
      //月卡到期时间
      return moment(this.order.cardInfo['endTime']*1000).format('YYYY-MM-DD')
    },
    courseStartTime:function(){
      //团课上课时间
      return moment(this.order.courseStartTime*1000).format('YYYY-MM-DD')
    },
    refundCreatedTime:function(){
      //退款申请时间
      return moment(this.order.refundCreatedTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    refundTime:function(){      
      //退款完成
      return moment(this.order.refundTime*1000).format('YYYY-MM-DD HH:mm:ss')
    },
    payment: function(){
      // 支付方式
      if(this.order.payment=='wxpay'){
        return "微信支付"
      }else if(this.order.payment=='alipay'){
        return "支付宝支付"
      }else{
        return ''
      }
    },
    ordertype: function(){
      var tmp = Date.parse( new Date() ).toString();  //当前时间戳10位
      tmp = tmp.substr(0,10);
      var sofar = (tmp-this.order.paidTime)/86400;  //日期差
      // console.log(sofar)

      //订单类型
      if(this.order.targetType=='clubGroupCourse'){
        this.courseBox = true   //显示课表 
        let coursetime = this.order.courseStartTime  //团课开课时间
        // console.log(tmp+'---'+coursetime)
        //超过7天退款时间或者超过开课时间 不可以退款
        if(sofar>7 || tmp>coursetime){
          //超出7天
          this.refundBtn = false  //隐藏退款按钮
          this.praiseBtn = true   //显示评价
        }else{
          //7天内
          this.refundBtn = true          
        }
        return "俱乐部团体课"
      }else if(this.order.targetType=='clubPtCourse'){
        this.courseBox = true  //显示课表 
            console.log(this.courseList.length)
        //超过7天退款时间或者预约过课程 不可以退款
        if(sofar>7 || this.courseList.length>0){
          //超出7天
          this.refundBtn = false  //隐藏退款按钮
          this.praiseBtn = true   //显示评价 
        }else{
          //7天内
          this.refundBtn = true 
        }
        return "教练私教课"
      }else if(this.order.targetType=='clubPracticeCard'){
        this.record = true  //显示预约记录  
        this.courseBox = false  //不显示课表
        this.refundBtn = false  //隐藏退款按钮
        return '俱乐部练球卡'
      }else if(this.order.targetType=='clubMonthCard'){
        this.courseBox = false  //不显示课表
        this.ordertypeInfo = true   //月卡不支持7天退换   
        this.refundBtn = false  //隐藏退款按钮
        // console.log(this.ordertypeInfo )
        return '俱乐部包月卡'
      }else{
        return ''
      }
    }
  }
}
</script>

<style lang="less">
.order-item{
    padding: .15rem;
    background-color:white;
    &__hd,&__bd{
        border-bottom: .01rem #f6f6f6 solid;
        & .tag{
          margin-left: -0.15rem;
        }
        &>.created{
          color: #F4B53A;
        }
        &>.paid{
          color:#06bf04;
        }
        &>.refunding{
          color: red;
        }
    }
    &__bd{
      & .rili{
        font-size: 0.6rem;
        color:#ddd
      }
    }
    &__info{
        &>div{
            // width: 30%;
        }
    }
}

.buybar{
    // height: .51rem;
}
// 二维码
.qrcode-wrap{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.5);
    z-index: 99;
    color: #fff;
    & #qrcode{
        position: fixed;
        top: 50%;
        left: 50%;
        border: 10px solid #fff;
        transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
    }
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderView.vue